<template>
    <div class="all-games-table-container">
        <sidebar
            :sidebar-dashboard="true"
            class="all-games-table-container__sidebar"
        ></sidebar>
        <creator-name
            class="all-games-table-container__creator-name"
        ></creator-name>
        <div class="all-games-table-container__summary-table">
            <div v-if="!getLoading" class="summary-table-container">
                <div class="return">
                    <button-back class="return__button-return"></button-back>
                </div>
                <div class="all-games-table-container__title">Compositions</div>
                <div class="summary-data-table">
                    <div class="summary-data-table__head-row">
                        <h3>Compositions name</h3>
                        <h3
                            style="margin: auto 0 auto auto; text-align: right;"
                        >
                            Number of Downloads
                        </h3>
                    </div>
                    <div
                        v-for="item in getCompositions"
                        :key="item.name"
                        class="summary-data-table__data"
                    >
                        <p>{{ item.name }}</p>
                        <p style="margin: auto 0 auto auto">
                            {{ item.downloads }}
                        </p>
                    </div>
                    <div class="summary-data-table__foot">
                        <h3>Total</h3>
                        <h3
                            v-if="getCompositions.lenth > 0"
                            style="margin: auto 0 auto auto"
                        >
                            {{ totalNumber(getCompositions, 'downloads') }}
                        </h3>
                        <h3 v-else style="margin: auto 0 auto auto">
                            0
                        </h3>
                    </div>
                </div>
            </div>
            <loading-table v-else></loading-table>
        </div>
    </div>
</template>

<script>
import LoadingTable from '@/components/common/loading/LoadingTable';
import { totalNumber } from '@/lib/calculations.js';
import { croppName } from '@/lib/croppName.js';
import { mapActions, mapGetters } from 'vuex';
import Sidebar from '@/components/sidebar/index';
import CreatorName from '@/components/dashboard/sections/DashboardCreatorName';
import ButtonBack from '@/components/common/ButtonBack.vue';

export default {
    name: 'AllCompositions',
    components: {
        LoadingTable,
        Sidebar,
        CreatorName,
        ButtonBack,
    },
    computed: {
        ...mapGetters('all_assets', {
            getCompositions: 'getCompositions',
            getLoading: 'getLoading',
        }),
        ...mapActions('all_assets', ['myCreationsAssets']),
    },
    created: function() {
        this.myCreationsAssets();
    },
    methods: {
        croppName,
        totalNumber,
    },
};
</script>

<style scoped lang="scss">
.all-games-table-container {
    @include main-grid-container;
    &__sidebar {
        grid-column: col-start / span 3;
        grid-row: auto;
        height: 100%;
    }
    &__creator-name {
        grid-column: col-start 4 / 13;
        grid-row: 1;
        @media (max-width: $sm-up) {
            grid-column: col-start / 13;
            margin-top: 3rem;
        }
    }
    &__summary-table {
        margin-top: -730px;
        grid-column: col-start 4 / 13;
        grid-row: 4;
        background: $white-main;
        height: 100%;
        @media (max-width: $lg-up) {
            grid-column: col-start / 13;
            margin-top: 0;
        }
        @media (max-width: $lg-up) {
            margin-top: 4rem;
        }
        @media (max-width: $xs-up) {
            margin-top: 2rem;
        }
    }
    &__title {
        display: block;
        margin: 1rem auto auto 3rem;
        width: 261px;
        height: 29px;
        color: $blue-main;
        font-family: $istok-font;
        font-size: 28px;
        font-weight: 700;
        letter-spacing: 0.44px;
        line-height: 53px;
    }
}
.summary-table-container {
    .return {
        padding-top: 20px;
        padding-left: 55px;
        width: 130px;

        @media (max-width: $sm-up) {
            padding-top: 70px;
            padding-left: 55px;
        }
        @media (max-width: $xs-up) {
            padding-left: 30px;
        }
    }
}
.summary-data-table {
    margin: 3rem auto 10rem 0;
    @media (max-width: $xs-up) {
        width: 90%;
        margin: 2rem auto 2rem 1rem;
        overflow-x: auto;
    }
    &__head-row {
        display: grid;
        grid-template-columns: 8fr 3fr 1fr;
        grid-template-rows: 4rem;
        width: 90%;
        height: 66px;
        border-radius: 6px 6px 0 0;
        background-color: #dce3e9;
        margin: 0 auto auto 3rem;

        @media (max-width: $xl-up) {
            width: 90%;
            height: 86px;
        }
        @media (max-width: $lg-up) {
            width: 90%;
        }
        @media (max-width: $xs-up) {
            grid-template-columns: 7fr 3fr 1fr;
            margin: 0 auto auto 0;
            width: 450px;
        }

        h3 {
            margin: auto auto auto 1rem;
            width: auto;
            height: 30px;
            color: $blue-main;
            font-family: $istok-font;
            font-size: 22px;
            font-weight: 700;
            letter-spacing: 0.18px;
            line-height: 30px;
        }
    }

    &__data {
        display: grid;
        grid-template-columns: 8fr 3fr 1fr;
        grid-template-rows: 4rem;
        width: 90%;
        height: 58px;
        background-color: rgba(244, 245, 246, 0.15);
        margin: 0 auto auto 3rem;
        border-bottom: 1px solid #e0e0e0;

        @media (max-width: $xl-up) {
            width: 90%;
        }
        @media (max-width: $lg-up) {
            width: 90%;
        }
        @media (max-width: $xs-up) {
            margin: 0 auto auto 0;
            width: 450px;
        }

        p {
            margin: auto auto auto 1rem;
            width: auto;
            color: $blue-main;
            font-family: $istok-font;
            font-size: 22px;
            font-weight: 400;
            letter-spacing: 0.18px;
            line-height: 30px;
        }
    }
    &__foot {
        display: grid;
        grid-template-columns: 8fr 3fr 1fr;
        grid-template-rows: 4rem;
        width: 90%;
        height: 66px;
        margin: 0 auto auto 3rem;
        border-radius: 0 0 6px 6px;
        background-color: rgba(244, 245, 246, 0.6);

        @media (max-width: $xl-up) {
            width: 90%;
        }
        @media (max-width: $lg-up) {
            width: 90%;
        }
        @media (max-width: $xs-up) {
            margin: 0 auto auto 0;
            width: 450px;
        }

        h3 {
            margin: auto auto auto 1rem;
            width: auto;
            height: 30px;
            color: $blue-main;
            font-family: $istok-font;
            font-size: 22px;
            font-weight: 700;
            letter-spacing: 0.18px;
            line-height: 30px;
        }
    }
}
</style>
